import { BehaviorSubject, Observable } from 'rxjs';
import rxjsOperators from 'rxjs-operators';
import { API_ENDPOINT_FIDC } from 'settings';
import apiService, { ApiService } from './api';

export type IFIDCAlert = {
  isAuthorized: boolean;
  message: string;
};
export class AlertFIDCService {
  private alertFidcUser$ = new BehaviorSubject<IFIDCAlert>(null);
  constructor(private api: ApiService) {}

  public loadFIDCAuthorized(userId: number): Observable<IFIDCAlert> {
    return this.api
      .get(`${API_ENDPOINT_FIDC}/public/users/check-status/${userId}`)
      .pipe(rxjsOperators.tap(response => this.alertFidcUser$.next(response)));
  }

  public getAlertFidcUser() {
    return this.alertFidcUser$.asObservable();
  }
}

export const AlertFIDCServiceFactory = () => new AlertFIDCService(apiService);

export const alertFIDCService = AlertFIDCServiceFactory();
